import { authApi } from '@/lib/api/auth.api';
import { toast } from 'sonner';
import { createLogger } from '@/lib/logger';
import { isTauri } from '@/lib/utils/tauri';
import { resetPersistedModuleFilters } from '@/store/filter-scope';

const logger = createLogger('utils/auth/auth-utils');

export async function handleLogout() {
  try {
    // Call the auth API to logout
    await authApi.logout();

    // For desktop, remove the current account from secure storage
    if (isTauri()) {
      try {
        const tauriModule = await import('@/lib/utils/tauri');
        if (tauriModule.desktopSecureStorage) {
          await tauriModule.desktopSecureStorage.deleteTokens();
        }
      } catch (storageError) {
        logger.error('[Auth] Failed to clear desktop storage:', storageError);
      }
    }

    // Clear essential auth-related storage
    resetPersistedModuleFilters();
    const keysToRemove = [
      'currentOrganizationId',
      'pendingInviteToken',
      'invitedOrganizationName',
      'scrambl-login-session',
      'organization-store',
      'organization-invite-store',
      'user-profile-storage'
    ];

    // Clear specified keys and any profile image cache
    Object.keys(localStorage).forEach(key => {
      if (keysToRemove.includes(key) || key.startsWith('user-profile-image-')) {
        localStorage.removeItem(key);
      }
    });

    // Force a hard navigation to login
    window.location.href = '/login';
  } catch (error) {
    logger.error('[Auth] Error during logout:', error);
    toast.error('Failed to sign out. Please try again.');
  }
}
